import createMemoryStorage from '../utils/memory-storage';

const NOOP = Function.prototype;

export const window =
  (typeof globalThis === 'object' && globalThis.window) || // fallback for non-browser environments (tests)
  ({} as Window & typeof globalThis);

export const document: Document =
  window.document ||
  // Minimal fallback stub for non-browser environments — Document has 250+
  // required members, so TS can't verify structural overlap without `unknown`.
  ({
    getElementById: () => null,
  } as unknown as Document);

export const history: History = window.history || ({} as History);

export const location: Location = window.location || ({} as Location);

export const addEventListener: Window['addEventListener'] =
  window.addEventListener || (NOOP as Window['addEventListener']);

export const Event: typeof globalThis.Event =
  window.Event || (NOOP as typeof globalThis.Event);

export const fetch: Window['fetch'] = window.fetch || (NOOP as Window['fetch']);

export const removeEventListener: Window['removeEventListener'] =
  window.removeEventListener || (NOOP as Window['removeEventListener']);

export const localStorage: Storage =
  window.localStorage || createMemoryStorage();

export const sessionStorage: Storage =
  window.sessionStorage || createMemoryStorage();
